<script lang="ts">
  import StarIcon from '../../components/icons/StarIcon.svelte';
  import Heading from '../Heading.svelte';
  import Paragraph from '../Paragraph.svelte';

  export let text = '';
  export let by = '';
  export let alignment;
  export let isSlide = false;
  export let rating = 5;
</script>

<div class="testimonial-card {isSlide ? 'slide' : ''}">
  <div class="card-content">
    <div class="card-quote" style="text-align: {alignment}">
      <svg
        style="color:var(--vlt-lp-accent);"
        width="34"
        height="28"
        viewBox="0 0 34 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.15157 4.4865C5.4899 1.9515 9.02823 0.666504 13.6666 0.666504H15.3332V5.36484L13.9932 5.63317C11.7099 6.08984 10.1216 6.98817 9.27157 8.3065C8.7499 9.11817 8.57823 9.98484 8.54157 10.6665H11.9999H13.6666C14.5882 10.6665 15.3332 11.4115 15.3332 12.3332V23.9998C15.3332 25.8382 13.8382 27.3332 11.9999 27.3332H1.9999C1.07823 27.3332 0.333234 26.5882 0.333234 25.6665V17.3332L0.338234 12.4682C0.323234 12.2832 0.00656694 7.89984 3.15157 4.4865ZM30.3332 27.3332H20.3332C19.4116 27.3332 18.6666 26.5882 18.6666 25.6665V17.3332L18.6716 12.4682C18.6566 12.2832 18.3399 7.89984 21.4849 4.4865C23.8232 1.9515 27.3616 0.666504 31.9999 0.666504H33.6666V5.36484L32.3266 5.63317C30.0432 6.08984 28.4549 6.98817 27.6049 8.3065C27.0832 9.11817 26.9116 9.98484 26.8749 10.6665H30.3332H31.9999C32.9216 10.6665 33.6666 11.4115 33.6666 12.3332V23.9998C33.6666 25.8382 32.1716 27.3332 30.3332 27.3332Z"
          fill="currentColor"
        />
      </svg>

      <!-- <p class="author">{@html by}</p> -->
      <Heading
        type={'h3'}
        css={'color:var(--vlt-lp-text); text-align:center;margin-top:43px;'}
      >
        {@html by}
      </Heading>
      <Paragraph css={'color:var(--vlt-lp-text);'}>
        {@html text}
      </Paragraph>
    </div>

    <div class="stars">
      {#each Array(rating) as _, index}
        <div class="star">
          <StarIcon />
        </div>
      {/each}
    </div>
  </div>
</div>

<style>
  .testimonial-card * {
    font-family: var(--font-family);
  }
  .testimonial-card.slide {
    width: auto;
    height: 100%;
    box-sizing: border-box;
  }
  .stars {
    display: flex;
  }
  .card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .testimonial-card {
    background-color: var(--vlt-lp-background);
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    grid-row-gap: 40px;
    padding: 40px 20px;
    transition:
      box-shadow 300ms ease,
      border-color 300ms ease;
    color: #07090d;
    text-align: center;
    border-style: solid;
    border-width: 1px;
    border-color: #edeff2;
    border-radius: 12px;
    text-decoration: none;
  }

  .card-quote {
    align-items: center;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    padding-bottom: 46px;
  }
  .card-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    width: auto;
  }
  .star {
    display: inline;
  }
  .star:not(:first-child) {
    margin-left: 5px;
  }

  @media screen and (min-width: 991px) {
    .testimonial-card:hover {
      border-color: transparent;
      cursor: pointer;
      box-shadow: 45px 45px 140px -48px rgba(7, 9, 13, 0.08);
    }
  }
  @media screen and (max-width: 990px) {
    .testimonial-card {
      width: auto;
    }
  }
</style>
